import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import enLocale from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enLocale,
      },
    },
    lng: localStorage.getItem('locale') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });
